export default __webpack_public_path__ + "static/media/amanda-baroni.eb433ef8.mp3";